import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  // Table,
  // Input,
  Button,
  Input,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { CSVExport } from "react-bootstrap-table2-toolkit"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import * as equipmentAction from "../../store/ZG93bmxvYWRxcg/actions"
import { isEmpty } from "lodash"
import { ToastContainer, toast } from "react-toastify"
import ButtonSpinner from "components/ButtonSpinner"
//import moment from "moment"
import Modal from "react-bootstrap/Modal"
import { QRCodeCanvas } from "qrcode.react"

const EquipmentService = (props) => {
  const { SearchBar } = Search
  const { dispatch, searchBtnStyle } = props

  //Export downlaod options
  const { ExportCSVButton } = CSVExport

  const title = "Download Qr"

  //Fetching API
  useEffect(() => {
    dispatch(equipmentAction.loadRecordsMetaData())
    dispatch(equipmentAction.loadEquipmentService())
  }, [])

  const update = useSelector((specificstate) => specificstate.downloadqr)
  const { equipment_service = [], recordsMetaData = {} } = update
  console.log("update is", update)
  console.log("update is", equipment_service)

  const [isDataLoaded, setIsDataLoaded] = useState(false)
  //Handle Change
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [mode, setMode] = useState([])
  const [equipmentType, setEquipmentType] = useState([])
  const [equipmentBrand, setEquipmentBrand] = useState([])
  const [equipmentProduct, setEquipmentProduct] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)

  const [printModal, setPrintModal] = useState(false)

  const [serviceData, setServiceData] = useState({
    equipmentCode: "",
    serialNo: "",
  })

  const handleChange = (e) => {
    setServiceData({ ...serviceData, [e.target.name]: e.target.value })
  }
  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )
  console.log(recordsMetaData, "recordsMetaData")

  const [equipmentAuditDetails, setEquipmentAuditDetails] = useState([])

  //Filter section
  const handleApply = () => {
    var searchCompany = company && company.value ? company.value : ""
    var searchBranch = branch && branch.value ? branch.value : ""
    var searchMode = mode && mode.value ? mode.value : ""
    var searchType =
      equipmentType && equipmentType.value ? equipmentType.value : ""
    var searchBrand =
      equipmentBrand && equipmentBrand.value ? equipmentBrand.value : ""
    var searchProduct =
      equipmentProduct && equipmentProduct.value ? equipmentProduct.value : ""
    var searchCode =
      serviceData && serviceData.equipmentCode ? serviceData.equipmentCode : ""
    var searchSerialNo =
      serviceData && serviceData.serialNo ? serviceData.serialNo : ""

    var searchFilter = {}

    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchMode) {
      searchFilter.mode = searchMode
    }
    if (searchType) {
      searchFilter.equipmentTypeId = searchType
    }
    if (searchBrand) {
      searchFilter.equipmentBrandId = searchBrand
    }
    if (searchProduct) {
      searchFilter.productVersionId = searchProduct
    }
    if (searchCode) {
      searchFilter.equipmentCode = searchCode
    }
    if (searchSerialNo) {
      searchFilter.serialNumber = searchSerialNo
    }
    setEquipmentAuditDetails([])
    setSubmitButton(false)

    if (!isEmpty(searchFilter)) {
      dispatch(equipmentAction.loadEquipmentService(searchFilter))
      setIsDataLoaded(true)
    }
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  const handleCompany = (e) => {
    setCompany(e)
    setBranch([])
    setMode([])
    setServiceData({
      equipmentCode: "",
      serialNo: "",
    })
    setEquipmentBrand([])
    setEquipmentProduct([])
    setEquipmentType([])
  }

  const [submitButton, setSubmitButton] = useState(false)

  let slNo = 0
  //const equipmentTable = []
  const equipmentTable =
    isDataLoaded && !isEmpty(equipment_service)
      ? equipment_service.map((equipment, index) => {
          slNo = slNo + 1
          const attachments =
            equipment.attachment && equipment.attachment.split(".").pop()

          return {
            sNo: slNo,
            key: index,
            _id: equipment._id,
            companyName: !isEmpty(equipment.companyName)
              ? equipment.companyName
              : "--",
            qrCode: (
              <div className="modal-body d-flex flex-column align-items-center">
                <QRCodeCanvas
                  id={`qr-gen-${equipment._id}`}
                  level="L"
                  size={256}
                  style={{ height: "40%", width: "47%" }}
                  value={equipment.equipmentQR}
                  renderAs="svg"
                />
              </div>
            ),
            checkField: (
              <>
                <Input
                  type="checkbox"
                  checked={equipmentAuditDetails.some(
                    (item) => item._id === equipment._id
                  )}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !equipmentAuditDetails.find(
                        (item) => item._id === equipment._id
                      )
                    ) {
                      setEquipmentAuditDetails([
                        ...equipmentAuditDetails,
                        equipment,
                      ])
                    } else {
                      setEquipmentAuditDetails(
                        equipmentAuditDetails.filter(
                          (item) => item._id !== equipment._id
                        )
                      )
                    }
                    const anyChecked = equipmentAuditDetails.some(
                      (item) => item._id !== equipment._id
                    )
                    setSubmitButton(anyChecked)
                  }}
                />
              </>
            ),
            notes: !isEmpty(equipment.notes) ? equipment.notes : "--",
            branchName: !isEmpty(equipment.branchName)
              ? equipment.branchName
              : "--",

            serialNumber: equipment.serialNumber,
            //           equipmentName: equipment.equipmentName,
            equipmentCode: equipment.equipmentCode,
            employeeName: equipment.employeName,
            employeeCode: equipment.employeCode,
            equipmentMode: equipment.mode,
            //           equipments: equipment.details,
            attachment:
              (equipment.attachment && attachments === "jpeg") ||
              (equipment.attachment && attachments === "jpg") ||
              (equipment.attachment && attachments === "png") ? (
                <a onClick={() => window.open(equipment.attachment, "_blank")}>
                  <span
                    style={{
                      textDecoration: "underline",
                      color: "#E40D8C",
                    }}
                  >
                    View Attachments
                  </span>
                </a>
              ) : (equipment.attachment && attachments === "mp3") ||
                (equipment.attachment && attachments === "m4a") ||
                (equipment.attachment && attachments === "mp4") ? (
                <a href={equipment.attachment}>
                  <audio controls>
                    <source src={equipment.attachment} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </a>
              ) : (
                ""
              ),

            brandName: equipment.equipmentBrandName,
            productName: equipment.productVersionName,
            equipmentType: equipment.equipmentTypeName,
            productVersion: equipment.productVersionName,
            isMapping: equipment.isMapping === true ? "YES" : "NO",
            isService: equipment.isService === true ? "YES" : "NO",
          }
        })
      : []
  console.log(equipmentAuditDetails, "equipmentAuditDetails")
  useEffect(() => {
    if (equipmentAuditDetails.length > 0) {
      setSubmitButton(true)
    } else {
      setSubmitButton(false)
    }
  }, [equipmentAuditDetails])
  //console.able columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      csvType: Number,
    },
    {
      dataField: "checkField",
      text: "Check Field",
      csvExport: false,
      sort: true,
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "qrCode",
      text: "QR Code",
      csvExport: false,
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "notes",
      text: "Notes",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "employeeCode",
      text: "Employee Code",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "equipmentMode",
      text: "Equipment Mode",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "equipmentType",
      text: "Equipment Type",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "brandName",
      text: "Brand",
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "attachment",
      text: "Attachment",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "productVersion",
      text: "Product Version",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "equipmentCode",
      text: "Equipment Code",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "serialNumber",
      text: "Serial No",
      csvType: Number,
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "isMapping",
      text: "Is Mapping",
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "isService",
      text: "Is Service",
      headerStyle: {
        minWidth: "170px",
      },
    },
  ]
  const modeOptions = [
    {
      label: "ADMIN",
      value: "ADMIN",
    },
    {
      label: "HR",
      value: "HR",
    },
    {
      label: "PHOTOGRAPHY",
      value: "PHOTOGRAPHY",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "VERMILION",
      value: "VERMILION",
    },
    {
      label: "DIVINE",
      value: "DIVINE",
    },
    {
      label: "ZG OPERATIONS",
      value: "ZG OPERATIONS",
    },
  ]

  const options = {
    sizePerPage: 50,
    //totalSize: equipment_service.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  const resetForm = () => {
    setCompany([])
    setBranch([])
    setMode([])
    setServiceData({
      equipmentCode: "",
      serialNo: "",
    })
    setEquipmentBrand([])
    setEquipmentProduct([])
    setEquipmentType([])
    setEquipmentAuditDetails([])
    setIsDataLoaded(false)
    dispatch(equipmentAction.loadEquipmentService())
  }

  const qrId = !isEmpty(equipmentAuditDetails)
    ? equipmentAuditDetails.map((m) => m._id)
    : ""
  const qrDownloadApi = () => {
    const submitQr = {
      _id: qrId,
    }
    console.log(submitQr, "qr ids")
    dispatch(equipmentAction.createDownloadQr(submitQr))
    toast.success("QR Downloaded successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    })
    //download qr code
    equipmentAuditDetails.forEach((record) => {
      const canvas = document.getElementById(`qr-gen-${record._id}`)
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream")
      let downloadLink = document.createElement("a")
      downloadLink.href = pngUrl
      downloadLink.download = record.equipmentQR
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    })

    setTimeout(() => {
      var searchCompany = company && company.value ? company.value : ""
      var searchBranch = branch && branch.value ? branch.value : ""
      var searchMode = mode && mode.value ? mode.value : ""
      var searchType =
        equipmentType && equipmentType.value ? equipmentType.value : ""
      var searchBrand =
        equipmentBrand && equipmentBrand.value ? equipmentBrand.value : ""
      var searchProduct =
        equipmentProduct && equipmentProduct.value ? equipmentProduct.value : ""
      var searchCode =
        serviceData && serviceData.equipmentCode
          ? serviceData.equipmentCode
          : ""
      var searchSerialNo =
        serviceData && serviceData.serialNo ? serviceData.serialNo : ""

      var searchFilter = {}

      if (searchCompany) {
        searchFilter.companyId = searchCompany
      }
      if (searchBranch) {
        searchFilter.branchId = searchBranch
      }
      if (searchMode) {
        searchFilter.mode = searchMode
      }
      if (searchType) {
        searchFilter.equipmentTypeId = searchType
      }
      if (searchBrand) {
        searchFilter.equipmentBrandId = searchBrand
      }
      if (searchProduct) {
        searchFilter.productVersionId = searchProduct
      }
      if (searchCode) {
        searchFilter.equipmentCode = searchCode
      }
      if (searchSerialNo) {
        searchFilter.serialNumber = searchSerialNo
      }

      if (!isEmpty(searchFilter)) {
        dispatch(equipmentAction.loadEquipmentService(searchFilter))
      }
      setSubmitButton(false)
      setIsDataLoaded(true)
      setEquipmentAuditDetails([])
    }, 2000)
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Inventory"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => handleCompany(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        value={branch}
                        onChange={(e) => setBranch(e)}
                        options={branchListOptions}
                        placeholder="Select Branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Mode"}
                        </Label>
                      </div>
                      <Select
                        name="mode"
                        value={mode}
                        onChange={(e) => setMode(e)}
                        options={modeOptions}
                        placeholder="Select Mode"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Type"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentType"
                        value={equipmentType}
                        onChange={(e) => setEquipmentType(e)}
                        options={
                          recordsMetaData ? recordsMetaData.typeOptions : []
                        }
                        placeholder="Select Equipment"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Brand"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentBrand"
                        value={equipmentBrand}
                        onChange={(e) => setEquipmentBrand(e)}
                        options={
                          recordsMetaData ? recordsMetaData.brandOptions : []
                        }
                        placeholder="Select Equipment Brand"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Product Version"}
                        </Label>
                      </div>
                      <Select
                        name="equipmentProduct"
                        value={equipmentProduct}
                        onChange={(e) => setEquipmentProduct(e)}
                        options={
                          recordsMetaData ? recordsMetaData.productOptions : []
                        }
                        placeholder="Select Product Version"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Equipment Code"}
                        </Label>
                      </div>
                      <Input
                        name="equipmentCode"
                        value={serviceData.equipmentCode}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Equipment Code"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Serial Number"}
                        </Label>
                      </div>
                      <Input
                        name="serialNo"
                        value={serviceData.serialNo}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter Serial Number"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => resetForm()}
                          className="btn btn-danger mx-1 btn-label simple-form-Reset-btn"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="button"
                          onClick={() => handleApply()}
                          className="btn btn-success mx-2 btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <PaginationProvider
                  pagination={paginationFactory(options)}
                  keyField="_id"
                  columns={columns}
                >
                  {({ paginationProps, paginationTableProps }) => (
                    <ToolkitProvider
                      keyField="_id"
                      data={equipmentTable}
                      columns={columns}
                      search
                      // selectRow={selectRow}
                    >
                      {(props) => (
                        <div>
                          <Col md="12" xl="12" lg="12" sm="12" xs="12">
                            <Row className="d-flex flex-row">
                              <Col className="mb-3" md="4">
                                <div className="d-flex flex-row ">
                                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                    <div
                                      className="position-relative mt-7"
                                      style={searchBtnStyle || null}
                                    >
                                      <SearchBar {...props.searchProps} />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </div>{" "}
                              </Col>
                              <Col>
                                <ExportCSVButton
                                  className="border float-right mx-10"
                                  style={{
                                    float: "right",
                                    backgroundColor: "#e40d8c",
                                    color: "#ffffff",
                                  }}
                                  {...props.csvProps}
                                >
                                  Download{" "}
                                </ExportCSVButton>{" "}
                              </Col>
                              <Col md="12" lg="12" xl="12" sm="12" xs="12">
                                <BootstrapTable
                                  {...props.baseProps}
                                  responsive
                                  striped={true}
                                  bordered={true}
                                  keyField="events"
                                  columns={columns}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                            <Row
                              style={{ marginTop: "5px" }}
                              className="align-items-md-center mt-30"
                            >
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline d-flex flex-row">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginTop: "8px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="text-md-right ms-auto"
                                  style={{ zIndex: 0 }}
                                >
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </PaginationProvider>

                {submitButton ? (
                  <>
                    <div className="float-end mt-3">
                      <Button
                        className="btn btn-success"
                        onClick={() => {
                          setPrintModal(true)
                        }}
                      >
                        Print qr Code
                      </Button>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {printModal && (
                  <Modal show={printModal} size="md">
                    <Modal.Header
                      style={{
                        backgroundColor: "#E40D8C",
                        color: "white",
                        minHeight: "65px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      {"Print Qr Code"}
                    </Modal.Header>
                    <Modal.Body>Do you want To Print the Qr Code?</Modal.Body>
                    <Modal.Footer>
                      <div>
                        <Button
                          type="submit"
                          onClick={() => {
                            setPrintModal(false)
                            setEquipmentAuditDetails([])
                          }}
                          style={{ fontSize: "10px", marginLeft: "20px" }}
                          className="btn btn-danger buttons"
                        >
                          {" "}
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          onClick={() => {
                            qrDownloadApi()
                            // downloadQrCode()
                            setTimeout(() => {
                              setPrintModal(false)
                            }, 500)
                          }}
                          style={{ fontSize: "10px", marginLeft: "20px" }}
                          className="btn btn-success buttons"
                        >
                          {" "}
                          Confirm
                        </Button>
                      </div>
                    </Modal.Footer>
                  </Modal>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
EquipmentService.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentService)
)
